import { Stack } from '@mui/material';
import dayjs from 'dayjs';
import { motion } from 'framer-motion';
import React from 'react';

export type AnimatedDaySectionProps = {
    selectedDate: dayjs.Dayjs;
    children: React.ReactNode;
};

export const AnimatedDaySection = ({ selectedDate, children }: AnimatedDaySectionProps) => (
    <motion.div
        key={selectedDate.format('YYYY-MM-DD')}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
    >
        <Stack direction="column" style={{ flex: 1, minHeight: 0 }}>
            {children}
        </Stack>
    </motion.div>
); 